import { render, staticRenderFns } from "./AddressDiscovery.vue?vue&type=template&id=4e0ced0f"
import script from "./AddressDiscovery.vue?vue&type=script&lang=js"
export * from "./AddressDiscovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports